module.exports = __webpack_public_path__ + "img/gley.c2c3284c.png";